import { CartProduct } from "@/interfaces";
import { CartItem } from "../../atoms";

export type CartRowProps = {
  item?: CartProduct;
  defaultProductImageUrl?: string;
  onQuantityChange?: (id: number, value: number, type?: "in-store"|"shipping") => void;
  onCoopAppliedChange?: (id: number, value: number) => void;
  itemType?: "in-store"|"shipping";
};

const CartRow: React.FC<CartRowProps> = ({
  item = undefined,
  defaultProductImageUrl = undefined,
  onQuantityChange = undefined,
  onCoopAppliedChange = undefined,
  itemType = "in-store",
}) => {
  return item ? (
    <CartItem
      item={item}
      defaultProductImageUrl={defaultProductImageUrl}
      itemType={itemType}
      onQuantityChange={(id: number, value: number, type?: "in-store"|"shipping") =>{
        onQuantityChange?.(id, value,type)}
      }
      onCoopAppliedChange={(id: number, value: number) =>
        onCoopAppliedChange?.(id, value)
      }
    />
  ) : null;
};

export default CartRow;
